import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=0a05d13d&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=0a05d13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05d13d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a05d13d')) {
      api.createRecord('0a05d13d', component.options)
    } else {
      api.reload('0a05d13d', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=0a05d13d&scoped=true&", function () {
      api.rerender('0a05d13d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24LP8l758n1Kf/JS/comp/PopupDialog.vue"
export default component.exports